// extracted by mini-css-extract-plugin
module.exports = {"sticky_container":"_19jhC839","page_header":"_rOKxjlMI"};